class RemoveFields {
    constructor() {
        this.iterateLinks();
    }

    iterateLinks() {
        document.addEventListener('click', e => {
            if (e.target && e.target.className == 'remove_fields') {
                this.handleClick(e.target, e);
            }
        });
    }

    handleClick(link, e) {
        if (!link || !e) return;
        e.preventDefault();

        let fieldParent = link.closest('.nested-fields');
        let deletedField = fieldParent
            ? fieldParent.querySelector('input[type="hidden"]')
            : null
        
        if (deletedField) {
            deletedField.value = 1;
            fieldParent.style.display = 'none';
            fieldParent.remove();
            max_colleague -= 1;
        }
    }
}

window.addEventListener('turbolinks:load', () => new RemoveFields());